import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'avatarColor',
  standalone: false,
})
export class AvatarColorPipe implements PipeTransform {
  private readonly colors = [
    '#6366f1', // indigo
    '#8b5cf6', // violet
    '#ec4899', // pink
    '#f43f5e', // rose
    '#f59e0b', // amber
    '#10b981', // emerald
    '#14b8a6', // teal
    '#06b6d4', // cyan
    '#3b82f6', // blue
    '#0ea5e9', // sky
    '#84cc16', // lime
    '#a855f7', // purple
  ];

  transform(name: string | null | undefined): string {
    if (!name) return this.colors[0];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return this.colors[Math.abs(hash) % this.colors.length];
  }
}
